/**
 * Barrel de compatibilidad: el módulo vive en `./sidebar/`.
 * Evita ENOENT cuando el resolver espera `sidebar.tsx` en lugar del directorio.
 */
export type {
  SidebarExplorePanelProps,
  SidebarNavItem,
  SidebarProps,
  SidebarTone
} from "./sidebar/index";
export {
  Sidebar,
  SidebarExplorePanel,
  SidebarMobileDrawer,
  useSidebarNavigation
} from "./sidebar/index";
